export default "__VITE_ASSET__DqrWkSoY__"